(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/pay-lyckoplatsen/assets/javascripts/draw-date-text.js') >= 0) return;  svs.modules.push('/components/tur/pay-lyckoplatsen/assets/javascripts/draw-date-text.js');
"use strict";


const fetchDrawData = svs.tur.pay_lyckoplatsen.fetchDrawData;
const logger = svs.tur.pay_lyckoplatsen.logger;
function drawDateText(_ref) {
  let _ref$isSubscription = _ref.isSubscription,
    isSubscription = _ref$isSubscription === void 0 ? false : _ref$isSubscription,
    startDate = _ref.startDate,
    endDate = _ref.endDate,
    _ref$hideNumDraws = _ref.hideNumDraws,
    hideNumDraws = _ref$hideNumDraws === void 0 ? false : _ref$hideNumDraws,
    _ref$weeks = _ref.weeks,
    weeks = _ref$weeks === void 0 ? 4 : _ref$weeks;
  if (isSubscription) {
    return 'Totalt 3 dragningar i veckan, tisdagar, torsdagar och söndagar. Prenumerationen har ingen bindningstid och betalas månadsvis med bankkort eller autogiro.';
  }
  const formattedStartDate = dateFns.format(new Date(startDate.regCloseTime), 'd/M', {
    locale: dateFns.sv
  });
  const formattedEndDate = dateFns.format(new Date(endDate.regCloseTime), 'd/M', {
    locale: dateFns.sv
  });
  const plural = weeks > 1 ? 'ar' : '';
  if (!hideNumDraws) {
    return "Totalt ".concat(weeks * 3, " dragningar, tisdag").concat(plural, ", torsdag").concat(plural, " och s\xF6ndag").concat(plural, ". Start ").concat(formattedStartDate, ", avslutas ").concat(formattedEndDate, ".");
  }
  return "Tisdag".concat(plural, ", torsdag").concat(plural, " och s\xF6ndag").concat(plural, ". Start ").concat(formattedStartDate, ", avslutas ").concat(formattedEndDate, ".");
}
function drawStartEndText(_ref2) {
  let startDate = _ref2.startDate,
    endDate = _ref2.endDate,
    _ref2$weeks = _ref2.weeks,
    weeks = _ref2$weeks === void 0 ? 4 : _ref2$weeks;
  const formattedStartDate = dateFns.format(new Date(startDate.regCloseTime), 'd/M', {
    locale: dateFns.sv
  });
  const formattedEndDate = dateFns.format(new Date(endDate.regCloseTime), 'd/M', {
    locale: dateFns.sv
  });
  const plural = weeks > 1 ? 'ar' : '';
  return {
    totalText: "Totalt ".concat(weeks * 3, " dragningar, tisdag").concat(plural, ", torsdag").concat(plural, " och s\xF6ndag").concat(plural, "."),
    startEndText: "Start ".concat(formattedStartDate, ", avslutas ").concat(formattedEndDate, ".")
  };
}
async function drawDateTextAsync(_ref3) {
  let _ref3$isSubscription = _ref3.isSubscription,
    isSubscription = _ref3$isSubscription === void 0 ? false : _ref3$isSubscription,
    numberOfWeeks = _ref3.numberOfWeeks,
    _ref3$hideNumDraws = _ref3.hideNumDraws,
    hideNumDraws = _ref3$hideNumDraws === void 0 ? false : _ref3$hideNumDraws;
  try {
    const _await$fetchDrawData = await fetchDrawData(numberOfWeeks),
      startDate = _await$fetchDrawData.firstDraw,
      endDate = _await$fetchDrawData.lastDraw;
    return drawDateText({
      isSubscription,
      startDate,
      endDate,
      hideNumDraws
    });
  } catch (error) {
    logger.error('Failed to fetch draw data', error);
  }
}
setGlobal('svs.tur.pay_lyckoplatsen', {
  drawDateText,
  drawDateTextAsync,
  drawStartEndText
});

 })(window);